export default class Config {
    public static readonly API_URL = 'https://ezrunpbra-api.onrender.com/api';
    public static readonly CACHE_EXPIRATION_TIME = 1 * 60 * 1000; // 15 minutes in milliseconds
    public static readonly TAB_PREFIX = 'EZ Run PBRA - '
    public static readonly SHEETS_KEY = 'AIzaSyDn9FyRHidIcqpCTyraSCGDi-kq9zRZVQ8';
    public static readonly SHEETS_URL = 'https://sheets.googleapis.com/v4/spreadsheets/1vQiv7t40GuVv3ehNhb8lVq4qO5HEQpZFGKMrcMvFsnM'
    public static readonly SPONSORS_SHEET = 'https://sheets.googleapis.com/v4/spreadsheets/1lu1pMiKj66P1wsinnBbnnGTMFt8muUNo2yYK1JKgqVc';
}